import { __awaiter } from 'tslib';

/**
 * Event class.
 */
class Event {
    /**
     * Constructor.
     * @param type Event type.
     * @param data Event data.
     * @param resultValue Event result initial value.
     */
    constructor(type, data = null, resultValue = null) {
        this.type = type;
        this.data = data;
        this.resultValue = resultValue;
        this.defaultPreventedValue = false;
        this.propagationStoppedValue = false;
    }
    /**
     * Gets the default handler prevent flag value.
     */
    get defaultPrevented() {
        return this.defaultPreventedValue;
    }
    /**
     * Sets the default handler prevent flag value.
     */
    preventDefault() {
        this.defaultPreventedValue = true;
    }
    /**
     * Gets the propagation stop flag value.
     */
    get propagationStopped() {
        return this.propagationStoppedValue;
    }
    /**
     * Sets the propagation stop flag value.
     */
    stopPropagation() {
        this.propagationStoppedValue = true;
    }
    /**
     * Gets the event result value.
     */
    get result() {
        return this.resultValue;
    }
    /**
     * Sets the event result value.
     */
    setResult(resultValue) {
        this.resultValue = resultValue;
    }
}

function subscribe(eventHandlers, eventHandler) {
    eventHandlers.push(eventHandler);
    const unsubscribe = () => {
        eventHandlers.splice(eventHandlers.indexOf(eventHandler), 1);
    };
    return { eventHandlers, unsubscribe };
}

function trigger(eventHandlers, type, data = null, resultValue = null) {
    return __awaiter(this, void 0, void 0, function* () {
        const event = new Event(type, data, resultValue);
        const eventRun = (runEventHandlers, runEvent) => __awaiter(this, void 0, void 0, function* () {
            const [eventHandler, ...eventHandlersRest] = runEventHandlers;
            if (eventHandler) {
                yield eventHandler(runEvent);
                return yield eventRun(eventHandlersRest, runEvent);
            }
            return runEvent;
        });
        return yield eventRun(eventHandlers, event);
    });
}

/**
 * Generated bundle index. Do not edit.
 */

export { Event, subscribe, trigger };

